module.exports = __webpack_public_path__ + "static/media/airtel-icons.8a39f1a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/fonts/airtel-icons.svg
// module id = 946
// module chunks = 0